import React from "react";
import ReactModal from "react-modal";

const QuizError = ({ isOpen, onClose }) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      borderRadius: "15px",
      transform: "translate(-50%, -50%)",
      width: "40%",
      height: "25%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "Space-between",
      gap: "2rem",
      padding: "px !important",
      backgroundColor: "#ffffff",
    },
    overlay: {
      background: "rgba(0,0,0,0.25)",
    },
  };
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      style={customStyles}
    >
      <div className="quizError-container">
        <div className="quizError-head">Quiz Error ?</div>
        <div>
          Throughout the quiz's choices, only activate the shot, long text,
          multiple-choice, and single-choice questions.
        </div>
        <div className="cancel-button">
          <button onClick={() => onClose()} className="cbtn">
            Cancel
          </button>
        </div>
      </div>
    </ReactModal>
  );
};

export default QuizError;
